<template>
  <div class="d-flex align-items-center">
    <b-form-checkbox
      v-model="itemStatus"
      class="custom-control-primary"
      name="check-button"
      switch
      @change="updateStatus"
      :disabled="loading"
    />
    <b-spinner v-if="loading" class="mr-1" variant="secondary" small />
  </div>
</template>

<script>
import { APIService } from '@/utils/api';
import { validateResource } from '@/utils/functions';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { BFormCheckbox, BSpinner } from 'bootstrap-vue';

export default {
  name: 'StatusCell',
  components: {
    ToastificationContent,
    BFormCheckbox,
    BSpinner,
  },
  props: {
    resource: {
      type: Object,
      required: true,
      validator: (value) => validateResource(value?.name),
    },
    itemId: {
      type: Number,
      required: true,
    },
    status: {
      type: Boolean,
      required: true,
      default: false,
    },
    resourceName: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      itemStatus: Boolean(this.status),
    };
  },
  computed: {
    businessID() {
      // Try to get from user module first
      if (this.$store.state.user && this.$store.state.user.businessID) {
        return this.$store.state.user.businessID;
      }
      // Then try root state
      if (this.$store.state.businessID) {
        return this.$store.state.businessID;
      }
      // Finally try userData
      if (this.$store.state.userData && this.$store.state.userData.businessID) {
        return this.$store.state.userData.businessID;
      }
      return 1; // Default for testing
    },
    userID() {
      // Try to get from user module first
      if (this.$store.state.user && this.$store.state.user.userID) {
        return this.$store.state.user.userID;
      }
      // Then try root state
      if (this.$store.state.userID) {
        return this.$store.state.userID;
      }
      // Finally try userData
      if (this.$store.state.userData && this.$store.state.userData.userID) {
        return this.$store.state.userData.userID;
      }
      return 1; // Default for testing
    },
    displayName() {
      return this.resourceName || this.resource.name;
    },
  },
  methods: {
    async updateStatus(updatedStatus) {
      console.log('=== updatedStatus', {
        updatedStatus,
        itemStatus: this.itemStatus,
      });
      this.loading = true;

      try {
        // Ensure the status is a proper boolean
        const boolStatus = Boolean(this.itemStatus);

        const response = await APIService.updateStatus(
          this.resource,
          this.itemId,
          boolStatus,
          this.businessID,
          this.userID
        );

        console.log('=== response', response);

        if (response?.data?.status === 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${this.displayName} Status Updated`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `${this.displayName} ${response?.data?.message}`,
            },
          });
        } else if (response?.data?.status === 'error') {
          // Handle error status even when HTTP status is successful
          this.itemStatus = !this.itemStatus; // Revert the toggle
          throw new Error(response?.data?.message || 'Failed to update status');
        } else {
          throw Error('Failed to update');
        }
      } catch (error) {
        console.error('Error updating status:', error);

        this.itemStatus = !this.itemStatus;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: error.message || `Failed to update ${this.displayName} status`,
          },
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
